module.exports = __webpack_public_path__ + "static/media/white-box.6a0aff9b.svg";